import Model, { attr, belongsTo } from '@ember-data/model';
import type { IconColor } from '@mylighthouse/prism-ember/types/components/prism/icon';
import { Type } from '@warp-drive/core-types/symbols';
import type { Dayjs } from 'dayjs';
import { tKey } from 'ember-intl';
import type MarketPerformanceSubscription from 'lumen/models/market-performance/subscription';

export const DATA_STATUSES = [
  'awaiting',
  'partially_updated',
  'updated',
] as const;

export type DataStatus = (typeof DATA_STATUSES)[number];

export const DATA_STATUS_ICON_COLORS: Record<DataStatus, IconColor> = {
  awaiting: 'warning',
  partially_updated: 'info',
  updated: 'success',
};

export const DATA_STATUS_TRANSLATIONS: Record<DataStatus, string> = {
  awaiting: tKey('general.data_status.awaiting'),
  partially_updated: tKey('general.data_status.partially_updated'),
  updated: tKey('general.data_status.updated'),
};

export interface DataStatusDetail {
  status: DataStatus;
  timestamp: Dayjs;
}

export default class MarketPerformanceDataStatus extends Model {
  [Type] = 'market-performance/data-status' as const;

  @belongsTo('market-performance/subscription', {
    async: false,
    inverse: 'dataStatus',
  })
  declare subscription: MarketPerformanceSubscription | null;

  @attr() declare reservation: DataStatusDetail;
  @attr('string') declare status: DataStatus;

  @attr() declare summary: DataStatusDetail;
}
